import { Bell } from 'icone/index';
import React from 'react';
const MonitoringLinkBanner = ({ projectId, versionId }) => {
  return (
    <div className='monitoringLinkBanner d-flex align-items-center justify-content-center my-3 simple-box'>
      <Bell
        width='30px'
        height='30px'
        className='mr-2 bell-shake-once'
        style={{ color: '#08a2aa' }}
      />
      <p className='m-0 p-0'>
        Ciao, questo progetto è sottoposto a monitoraggio. Se non l'hai ancora fatto, compila e
        sottometti il monitoraggio seguendo{' '}
        <a href={`/monitoraggio/${projectId}/ver=${versionId}`}>questo link</a>.
      </p>
    </div>
  );
};

export default MonitoringLinkBanner;
